function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShippingSave = function SvgShippingSave(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 1024 1024"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M62.9 592.82s268.63 145.83 364.27 366.67c0 0 238.75-545.83 533.72-625 0 0-109.58-141.67-42.91-270.83 0 0-420.37 325-490.81 658.33l-191.28-287.5S177.41 571.98 62.9 592.82",
    style: {
      fill: "#f59f3d"
    }
  }));
};
export default SvgShippingSave;